export const getCategories = (state) => {
    return state.categories;
};

export const getLeveranciers = (state) => {
    return state.leveranciers;
}

export const getSelectedCategory = (state) => {
    return state.selectedCategory;
}

export const getSearchTerm = (state) => {
    return state.searchTerm;
}